module.exports = __webpack_public_path__ + "img/student_exam_wrong.f9ef5fb1.svg";